import {ACTIONS} from '../../util/constants';

export const setFormData = payload => ({
  type: ACTIONS.SET_FORM_DATA,
  payload
});